import React from "react";
import { PageHeading } from "components/common";
import { useTranslation } from "react-i18next";
import { default as DeleteTextBg } from "locales/bg/DeleteText";
import { default as DeleteTextEn } from "locales/en/DeleteText";
import { Box } from "@material-ui/core";
import { useStyles } from "styling/mainStyles";
import { EN, BG } from "translation";
import { useLocale } from "hooks";

const DeleteAccount = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { localeState } = useLocale();

  return (
    <>
      <PageHeading>{t("deleteDataPageHeading")}</PageHeading>
      <Box className={classes.pageText}>
        {localeState.locale === EN ? <DeleteTextEn /> : <DeleteTextBg />}
      </Box>
    </>
  );
};

export default DeleteAccount;
